import { Box, Flex } from '@chakra-ui/react'
import {
  GreyGrey40,
  GreyGrey80,
  GreyWhite,
  IndigoIndigo50,
  Lato12Regular
} from '@sequencehq/design-tokens'
import { format } from '@sequencehq/utils/dates'
import { TIMELINE_DAY_INDICATORS_Z_INDEX } from '../timeline.constants'

const DAY_INDICATOR_THEMES = {
  today: {
    backgroundColor: IndigoIndigo50,
    color: GreyWhite,
    zIndex: TIMELINE_DAY_INDICATORS_Z_INDEX
  },
  hover: {
    backgroundColor: GreyGrey40,
    color: GreyGrey80,
    zIndex: TIMELINE_DAY_INDICATORS_Z_INDEX + 10
  }
}

export const ScheduleTimelineDayIndicator = (props: {
  offset: number
  date: Date
  showLabel?: boolean
  theme: 'today' | 'hover'
  height: number
}) => {
  const theme = DAY_INDICATOR_THEMES[props.theme]

  return (
    <>
      {props.showLabel && (
        <Flex
          zIndex={theme.zIndex + 1}
          alignItems="center"
          justifyContent="center"
          position="absolute"
          top="27px"
          width="42px"
          left={`${props.offset}px`}
          transform="translateX(-50%)"
          borderRadius="4px"
          {...Lato12Regular}
          fontSize="10px"
          backgroundColor={theme.backgroundColor}
          color={theme.color}
          pointerEvents="none"
        >
          {format(props.date, 'MMM dd')}
        </Flex>
      )}
      <Box
        zIndex={theme.zIndex}
        height={`${props.height}px`}
        width="1px"
        position="absolute"
        top="0"
        left={`${props.offset}px`}
        pointerEvents="none"
        backgroundColor={theme.backgroundColor}
      />
    </>
  )
}
